import { useMutation } from "@tanstack/react-query";
import { apiFetch, ApiError } from "../api/client";

export interface PasswordChangeInput {
  readonly currentPassword: string;
  readonly newPassword: string;
}

// Posts to POST /auth/password. On a wrong current password the server
// returns validation_failed with a `currentPassword` field error, which
// the form surfaces inline via pickFieldError.
export function usePasswordChange() {
  return useMutation<void, ApiError, PasswordChangeInput>({
    mutationFn: (input) =>
      apiFetch<void>("/auth/password", { method: "POST", body: input }),
  });
}
